业务准入提示信息列表组件
@liwei2
<template>
  <div class="checkList-mask flex flex-middle flex-center" v-if="checkList.length>0&&isShow">
    <!-- <i class="close-btn" @click="close"></i> -->
    <div class="checkList-wrap">
      <p v-if="title" class="title">{{title}}</p>
      <p v-if="!hideSubtitle" class="msg">- 请联系工作人员协助处理 -</p>
      <el-main>
        <ul>
          <li v-for="(list,key) in newCheckList" :key="key">
            <i class="icon" :class="listIcon(list.RESTRICT_TYPE)"></i>
            <div class="content-wrap">
              <span class="text-content">{{list.HANDLE_TIP}}</span>
              <p v-if="list.subList">
                <span v-for="(field ,i) in list.subList" :key="i">{{field.fieldName + '：' + field.fieldValue}}</span>
              </p>
            </div>
            <button @click="clickItem(list)"
              v-if="Boolean(Number(list.MENU_ID))">{{list.MENU_NAME || dealButtonTxt}}</button>
          </li>
        </ul>
      </el-main>
    </div>
  </div>
</template>

<script>
import custService from "@/service/cust-service";
import oppService from "@/service/opp-service";
export default {
  data () {
    return {
      hasForbin: false, //是否存在禁止项
      isShow: true,
      newCheckList: []
    };
  },
  props: {
    checkList: Array,
    title: {
      type: String,
      default: "销户检查结果"
    },
    nextStepText: {
      type: String,
      default: "跳过"
    },
    dealButtonTxt: {
      type: String,
      default: "完善"
    },
    hideSubtitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    busiCode () {
      return window.vm.$store.state.busicode;
    },
    isLogin () {
      return window.vm.$store.state.isLogin;
    },
    custInfo () {
      return (
        window.vm.$storage.getJsonSession(window.vm.$definecfg.CUSTOMER_INFO) ||
        {}
      );
    },
    userType () {
      return window.vm.$store.state.usertype;
    }
  },
  mounted () {
    this.handelWithPreCheckList();
  },
  watch: {
    checkList (v) {
      this.handelWithPreCheckList();
    }
  },
  methods: {
    handelWithPreCheckList () {
      let accessDataArr = _.orderBy(this.checkList, ["RESTRICT_TYPE"], ["asc"]),
        refuseArr = _.filter(accessDataArr, o => o.RESTRICT_TYPE == "0"),
        banArr = _.filter(accessDataArr, o => o.RESTRICT_TYPE == "1"),
        warnArr = _.filter(accessDataArr, o => o.RESTRICT_TYPE == "2"),
        remindArr = _.filter(accessDataArr, o => o.RESTRICT_TYPE == "3");

      if (refuseArr.length) {
        //有拒绝项
        this.newCheckList = refuseArr.concat(
          this.clearOtherRestrictTypeMenuId([banArr, warnArr, remindArr])
        );
      } else if (banArr.length) {
        this.newCheckList = banArr.concat(
          this.clearOtherRestrictTypeMenuId([warnArr, remindArr])
        );
      } else if (warnArr.length) {
        this.newCheckList = warnArr.concat(
          this.clearOtherRestrictTypeMenuId([remindArr])
        );
      } else {
        this.newCheckList = remindArr;
      }

      this.newCheckList.forEach(item => {
        if (["0", "1"].indexOf(item.RESTRICT_TYPE) != -1) {
          //存在禁止项
          this.hasForbin = true;
        }
      });
    },
    clearOtherRestrictTypeMenuId (arr) {
      let arrCopy = _.cloneDeep(arr);
      _.forEach(arrCopy, function (arr2) {
        _.forEach(arr2, function (item) {
          item.MENU_ID = "";
        });
      });
      return _.flattenDeep(arrCopy);
    },
    close () {
      this.isShow = false;
      if (this.isLogin) {
        window.vm.$router.push({ path: "/homeCustomer" });
      } else {
        window.vm.$router.push({ path: "/home" });
      }
    },
    listIcon (listIconType) {
      switch (listIconType) {
        case "0":
          return "refuse";
        case "1":
          return "forbid";
          break;
        case "2":
          return "wran";
          break;
        case "3":
          return "normal-icon";
          break;
        default:
          return "normal-icon";
          break;
      }
    },
    clickItem (menu) {
      let that = this,
        custInfo = window.vm.$storage.getJsonSession(
          window.vm.$definecfg.CUSTOMER_INFO
        );

      if (
        menu.BUSI_CODE == "V0008" &&
        menu.CON_ID == "554" &&
        menu.MENU_ID == "90002007" &&
        this.busiCode == "V0035"
      ) {
        return that.$syscfg
          .K_Request("W0000020", {
            ID_CODE: custInfo.ID_CODE,
            YZT_CHANNEL: that.getSystemParam("VTM_YZT_CHANNEL")
          })
          .then(data => {
            if (data.Code == "0") {
              let cuacctList_ = [];
              //所有客户号的信息
              that.custInfoAllList = data.Data;
              //拼接所有的主资金账号数组
              _.forEach(data.Data, function (item) {
                let cuacctListTemp_ = _.filter(item.CUST_CUACCT_INFO, function (
                  item1
                ) {
                  return item1.MAIN_FLAG == "1";
                });
                cuacctList_ = cuacctList_.concat(cuacctListTemp_);
              });
              //主资金账户数组对象
              that.mainCuacctListObj = _.uniqBy(cuacctList_, "CUACCT_CODE");
              //主资金账户数组
              that.cuacctList = _.pluck(that.mainCuacctListObj, "CUACCT_CODE");
              if (that.cuacctList.length > 0) {
                window.vm.$router.replace({
                  name: "home",
                  params: {
                    busiCode: menu.BUSI_CODE,
                    menuName: menu.MENU_NAME,
                    userType: "0"
                  }
                });
              } else {
                window.vm.$router.replace({
                  name: "home",
                  params: {
                    busiCode: menu.BUSI_CODE,
                    menuName: menu.MENU_NAME,
                    userType: "exteral"
                  }
                });
              }
            }
          })
          .catch(err => {
            that.alert("校验客户信息失败，请重试！");
            consoleLog(err);
            that.myLoading({
              showLoading: false
            });
          });
      }

      if (menu.IS_RECOD_CUST) {
        //调用账户系统接口L1102335留痕“已提示客户为‘失联客户’” toDo
        custService
          .W0000201({
            SPECIAL_FLAG_TYPE: "02",
            INT_ORG: custInfo.INT_ORG,
            CUST_CODE: custInfo.CUST_CODE
          })
          .then(function (flag) {
            if (flag) {
              that.goToMenu(menu);
            }
          })
          .catch(function (err) {
            that.alert(err);
          });
      } else {
        that.goToMenu(menu);
      }
    },
    //获取系统参数
    getSystemParam (parmCode) {
      return oppService.getSysCommonParamsFromCacheObjs(parmCode);
    },
    goToMenu (menu) {
      if (menu.BUSI_CODE_ACS && menu.BUSI_CODE_ACS !== "") {
        //更新业务名称和业务代码
        window.vm.$store.commit(
          window.vm.$types.UPDATE_BUSI_CODE,
          menu.BUSI_CODE_ACS
        );
        window.vm.$storage.setSession(
          window.vm.$definecfg.BUSI_NAME,
          menu.MENU_NAME
        );

        //如果是双录业务 需要保存标志
        if (
          menu.MENU_ID == "99665000" ||
          _.startsWith(menu.BUSI_CODE_ACS, "P")
        ) {
          consoleLog("保存双录标志");
          window.vm.$storage.setSession(
            window.vm.$definecfg.IS_DOUBLE_RECORD,
            1
          );
        }

        let ps = { busiCode: menu.BUSI_CODE_ACS, userType: " " };
        if ("userType" in menu) {
          window.vm.$store.commit(
            window.vm.$types.UPDATE_USER_TYPE,
            this.userType
          );
          ps["userType"] = this.userType;
        }

        window.vm.$router.replace({
          name: "bizInfo",
          params: ps
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@keyframes pop {
  from {
    bottom: -100%;
  }
  to {
    bottom: 0;
  }
}
.checkList-mask {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.7);
  .close-btn {
    position: absolute;
    top: 230px;
    right: 400px;
    display: block;
    width: 70px;
    height: 70px;
    background-size: 100% 100%;
    background-image: url("~@img/spec/00deny/icon_guanbi.png");
  }
  .checkList-wrap {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    height: 100%;
    left: 50%;
    bottom: 0;
    width: 1300px;
    // height: 920px;
    padding: 0 70px;
    border-radius: 4px;
    background-color: #fff;
    transform: translateX(-50%);
    overflow-y: scroll;
    animation: pop 0.2s linear;
    img {
      width: 66px;
      height: 66px;
    }
    .title {
      padding: 50px 0 15px;
      margin: 0;
      text-align: center;
      font-size: 56px;
      color: #232323;
      font-weight: bold;
    }
    .msg {
      margin: 0;
      font-size: 25px;
      color: #81848c;
      text-align: center;
    }
    ul {
      width: 100%;
      // height: 388px;
      overflow-y: auto;
      margin: 0;
      padding: 0;
      background: #ffffff;
      border-radius: 8px;
      list-style: none;

      li {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin-top: 20px;
        width: 100%;
        min-height: 110px;
        padding: 0 30px;
        border-radius: 4px;

        font-size: 24px;
        color: #232323;
        line-height: 36px;
        background-color: #eff2f6;
        .icon {
          display: block;
          width: 65px;
          height: 34px;
          margin-right: 16px;
          background-size: 100% auto;
          background-repeat: no-repeat;
          &.forbid {
            background-image: url("~@img/spec/00deny/icon_jinzhi.png");
          }
          &.refuse {
            background-image: url("~@img/spec/00deny/icon_jujue.png");
          }
          &.wran {
            background-image: url("~@img/spec/00deny/icon_jinggao.png");
          }
        }
        .content-wrap {
          width: 814px;
          margin-right: 52px;
          text-align: left;
          .text-content {
            font-size: 25px;
            font-weight: 600;
            line-height: 1.2;
            span {
              display: inline-block;
              &:first-child {
                margin-right: 25px;
              }
            }
          }
        }
        button {
          width: 134px;
          height: 50px;
          border: 2px solid #1062d1;
          border-radius: 25px;
          color: #1062d1;
          font-size: 22px;
          background-color: #ffffff;
          flex: 0 0 auto;
        }
      }
    }
    .footer {
      text-align: center;
      padding: 25px 0;
      height: 130px !important;
      width: 100%;
      border-top: 1px solid #d6d6d6;
      text-align: center;
      background-color: white;
      overflow: hidden;
      .el-button {
        min-width: 220px;
        width: auto;
        height: 80px;
        margin: 0 20px;
        // background: linear-gradient(45deg, #3556dd, #4667e9);
        border-radius: 4px;
        font-size: 32px;
        font-weight: 500;
        // color: #fff;
        &:first-child {
          color: #5172f6;
          background-color: #ffffff;
          box-shadow: 0px 6px 14px 0px rgba(0, 0, 0, 0.08);
          border: solid 2px #5172f6;
        }
        &:last-child {
          color: #fff;
          background: linear-gradient(45deg, #3556dd, #4667e9);
          &.is-disabled {
            background-color: #c0c4cc;
            box-shadow: 0px 6px 14px rgba(146, 153, 162, 0.26);
            border-color: #f5f7fa;
            background-image: linear-gradient(90deg, #ecf5ff 0%, #ecf5ff 100%);
          }
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/lib/ui/default/popup/src/content/checklist.vue